// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/cnquery_cnspec_actions.go

import { type Scope } from "~/hooks/useScope";
import { DELETE_FRAMEWORK } from "./action";

export function canDeleteFramework(scope: Scope): boolean {
  return scope.iamActions.includes(DELETE_FRAMEWORK);
}
